// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {ModalContentFormModuleLayout} from 'app_components/modules/admin/course/modalContentForm'
// @end

// @import events
// @end

// @import utils
import { I18nUtil } from 'app_utils/i18n'
// @end

// @import services
// @end

// @import types
// @end

// @ADD Component types
interface IModalContentFormModuleProps {
  open: boolean
  handleClose: (data:any)=>void
  editData?: any
}
interface IModalContentFormModuleState {
  customErrors: any
  processing: boolean
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class ModalContentFormModule extends Component<IModalContentFormModuleProps, IModalContentFormModuleState> {

  private i18nUtil: I18nUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IModalContentFormModuleProps) {
    super(props)
    this.state = {
      customErrors: null,
      processing: false
    }

    this.i18nUtil = new I18nUtil()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}



  // @Add custom methods
  onHandleSubmit = async (data: any) => {
    this.setState({processing: true, customErrors: null})

    let customErrors: any = {}

    // @INFO: Si existen campos con error retorno
    if (Object.keys(customErrors).length > 0) {
      this.setState({customErrors, processing: false})
      return false
    }

    if (data.data) {
      try {
        data.data = JSON.parse(data.data)
      } catch(e) {}
    }

    this.setState({processing: false})
    this.props.handleClose({status: true, data})
  }

  render() {
    return(
      <ModalContentFormModuleLayout
        open={this.props.open}
        handleClose={this.props.handleClose}
        onHandleSubmit={this.onHandleSubmit}
        customErrors={this.state.customErrors}
        processing={this.state.processing}
        editData={this.props.editData}
      />
    )
  }
}

export default connect(mapStatesToProps)(ModalContentFormModule)
